import {MdbsCore} from "@/api/tsclient";
import IQueryMessageDto = MdbsCore.IQueryMessageDto;

export enum QueryStage {
    OPEN = "OPEN",
    PENDING = "PENDING",
    NO_LONGER_RELEVANT = "NO_LONGER_RELEVANT",
    INVISIBLE = "INVISIBLE",
    CLOSED = "CLOSED"
}

export enum QueryStageClosedReason
{
    NONE = "NONE",
    SOLVED = "SOLVED",
    ACCEPTED = "ACCEPTED",
    REVOKED = "REVOKED"
}

export enum MessageType {
    COMMENT = "Comment",
    STATE_CHANGE = "StateChange"
}

export enum PriorityState {
    NORMAL = "NORMAL",
    HIGH = "HIGH"
}

export const ReferenceTypeMapping = [
    {referenceType: "InstrumentField", text: "Instrumentfeld"},
    {referenceType: "VisitField", text: "Visitenfeld"},
    {referenceType: "StudyPatientField", text: "Patientenfeld"},
    {referenceType: "StudyPatient", text: "Patient"},
    {referenceType: "Instrument", text: "Instrument"},
    {referenceType: "StudyInstitute", text: "Zentrum"},
    {referenceType: "Visit", text: "Visite"},
]

export const answerStateText = function (
    stageState: string | undefined,
    closedReason: string | undefined,
    lastComment: IQueryMessageDto | undefined) {
    if (stageState == QueryStage.CLOSED) {
        if (closedReason == QueryStageClosedReason.NONE)
            return " (Kein Grund)";
        if (closedReason == QueryStageClosedReason.REVOKED)
            return " (Zurückgezogen)";
        if (closedReason == QueryStageClosedReason.SOLVED)
            return " (Abgeschlossen)";
        if (closedReason == QueryStageClosedReason.ACCEPTED)
            return " (Akzeptiert/Geprüft)"
    }

    if (!lastComment)
        return " (Neu)";

    if (lastComment?.creatingUserRoleIdentifier == "DataManager" ||
        lastComment?.creatingUserRoleIdentifier == "SafetyManager")
        return " (Erneuert)";

    if (lastComment?.creatingUserRoleIdentifier == "Physician" ||
        lastComment?.creatingUserRoleIdentifier == "Nurse")
        return " (Beantwortet)"

    return "";
}

